import { render, staticRenderFns } from "./SelectLimitedHeight.vue?vue&type=template&id=38cd577a"
import script from "./SelectLimitedHeight.vue?vue&type=script&lang=ts"
export * from "./SelectLimitedHeight.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports